import { i18next } from '@frontend/i18n';

type BuildIncomingDialablesParams = {
  isDeviceExtensionRoute: boolean;
  phoneNumbers: IncomingDialablePhoneNumber[];
  extensionNumbers: number[];
};

export const MAX_VISIBLE_DIALABLE_LABELS = 9;
export type IncomingDialable = {
  label: string;
  tooltip: string;
};

type IncomingDialablePhoneNumber = {
  label: string;
  name?: string;
};

export const buildIncomingDialables = ({
  isDeviceExtensionRoute,
  phoneNumbers,
  extensionNumbers,
}: BuildIncomingDialablesParams) => {
  const validPhoneNumbers: IncomingDialable[] = phoneNumbers
    .filter((phoneNumber) => !!phoneNumber.label)
    .map((phoneNumber) => ({
      label: phoneNumber.label,
      tooltip: phoneNumber.name || phoneNumber.label,
    }));

  const extensions: IncomingDialable[] = extensionNumbers.map((extensionNumber) => {
    const extensionNumberString = String(extensionNumber);
    return {
      label: i18next.t('Ext {{extensionNumber}}', { ns: 'phone', extensionNumber: extensionNumberString }),
      tooltip: i18next.t('Extension {{extensionNumber}}', { ns: 'phone', extensionNumber: extensionNumberString }),
    };
  });

  if (isDeviceExtensionRoute && extensions.length === 1 && validPhoneNumbers.length === 0) {
    return [];
  }

  return isDeviceExtensionRoute ? [...extensions, ...validPhoneNumbers] : [...validPhoneNumbers, ...extensions];
};

export const getIncomingDialablesGridData = (
  incomingDialables: IncomingDialable[],
  maxVisibleDialables = MAX_VISIBLE_DIALABLE_LABELS
) => {
  const visibleDialables = incomingDialables.slice(0, maxVisibleDialables);
  const hiddenCount = Math.max(incomingDialables.length - visibleDialables.length, 0);

  return { visibleDialables, hiddenCount };
};
